<div>
    <div class="table-responsive pt-4">
        <table class="table table-hover mb-0">
            <thead>
            <tr>
                <th>Product</th>
                <th>Product Type</th>
                <th>Price</th>
                <th>Discounted Amount</th>
                <th>Price After Discount</th>
                <th>Quantity</th>
                <th>Total</th>
                <th>Total After Discount</th>
                <th>Quantity Dispensed</th>
                <th>Total Amount Dispensed</th>
<!--                <th>Discounted Amount Dispensed</th>-->
                <th>Total Discounted Amount Dispensed</th>
                <th>Total Dispensed After Discount</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(orderItem, index) in orderItems" :key="index">
                <td>{{orderItem.product}}</td>
                <td>{{orderItem.productType}}</td>
                <td>{{orderItem.priceAsString}}</td>
                <td>{{orderItem.discountedAmountAsString}}</td>
                <td>{{orderItem.priceAfterDiscountAsString}}</td>
                <td>
                    {{orderItem.quantity}}
                </td>
                <td>{{orderItem.totalAsString}}</td>
                <td>{{orderItem.totalAfterDiscountAsString}}</td>
                <td>
                    <input type="number" v-model="orderItem.quantityDispensed" @input="onQuantityInput(orderItem)" />
                </td>
                <td>{{orderItem.totalAmountDispensedAsString}}</td>
<!--                <td>{{orderItem.discountedAmountDispensed}}</td>-->
                <td>{{orderItem.totalDiscountedAmountDispensedAsString}}</td>
                <td>{{orderItem.totalDispensedAfterDiscountAsString}}</td>
            </tr>
            </tbody>
        </table>
<!--        <div class="float-right">-->
<!--            Grand Total {{orderTotalAsString}}-->
<!--        </div>-->
    </div>
    
</div>